import type { ReactNode } from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { OnboardingStepActiveContext } from "./use-step-dialog";

// Keep drafts and failed upload queues when navigation or staff changes move
// the customer to another step. Hidden steps cannot receive keyboard focus.
export const PreservedStep = ({
  active,
  children,
}: {
  active: boolean;
  children: ReactNode;
}) => (
  <OnboardingStepActiveContext.Provider value={active}>
    <Stack
      align="start"
      gap={4}
      className={cn("w-full", cn({ hidden: !active }))}
      aria-hidden={!active}
    >
      {children}
    </Stack>
  </OnboardingStepActiveContext.Provider>
);
